@use "@fukuri-admins/ui/layout" as *;

.screen {
  @include screen;
}

.NoSideMenu {
  padding-left: 0;
}

.content {
  @include content;
}

.body {
  @include body;
}

.BannerWrapper {
  position: fixed;
  bottom: spacing('24');
  right: spacing('24');
}
